// Port of https://github.com/react-bootstrap/react-bootstrap/blob/master/src/Collapse.js
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { UISwitch } from '@deephaven/components';
import "./LogLevelMenuItem.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class LogLevelMenuItem extends PureComponent {
  constructor(props) {
    super(props);
    this.handleSwitchClick = this.handleSwitchClick.bind(this);
  }
  handleSwitchClick() {
    var _this$props = this.props,
      logLevel = _this$props.logLevel,
      onClick = _this$props.onClick;
    onClick(logLevel);
  }
  render() {
    var _this$props2 = this.props,
      logLevel = _this$props2.logLevel,
      on = _this$props2.on;
    return /*#__PURE__*/_jsxs("div", {
      className: classNames('log-level-menu-item', logLevel),
      children: [/*#__PURE__*/_jsx(UISwitch, {
        on: on,
        onClick: this.handleSwitchClick
      }), logLevel]
    });
  }
}
export default LogLevelMenuItem;
//# sourceMappingURL=LogLevelMenuItem.js.map